import React, { Component } from 'react';
import { TableRow } from './TableRow.js';

export const TableColumnType = {
    Default: "default",
    Bool: "bool",
    String: "string",
    ColoredString: "coloredString",
    Double: "double",
    Date: "date",
    Status: "status",
    Phone: "phone",
    Email: "email",
    DateTime: "datetime",
    Enum: "enum",
    Button: "button",
    Comment: "comment",
    DocLink: "docLink",
    Reorder: "reorder"
}
export class Table extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        let { columns, items } = this.props;
        return (
            <div className="table-block">
                <div className="table-response">
                    <table>
                        <thead>
                            <tr>
                                {columns.map(column =>
                                    <th key={column.id} name={column.name} style={{ display: (column.hidden === true ? "none" : "table-cell") }}>
                                        <span>
                                            {column.headerName}
                                        </span>
                                    </th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, index) => (
                                <TableRow key={index} cols={columns} item={item}></TableRow >
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}